import apiClient from './client';

export interface Server {
  instanceId: string;
  instanceName: string;
  instanceType: string;
  state: string;
  region: string;
  environment?: string;
  account?: string;
}

export interface RefreshServersResponse {
  success: boolean;
  instances: Server[];
}

export const serversApi = {
  // Get all discovered servers (cached)
  getAll: async (): Promise<Server[]> => {
    const response = await apiClient.get<Server[]>('/servers');
    return response.data;
  },

  // Refresh server cache and get updated list
  refresh: async (): Promise<RefreshServersResponse> => {
    const response = await apiClient.post<RefreshServersResponse>('/servers/refresh');
    return response.data;
  },
};
